import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6af71f7e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "New Customer", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["onSubmit"]
const _hoisted_6 = { class: "box" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Contact Information", -1))
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "form-field" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "First Name:", -1))
const _hoisted_11 = {
  key: 0,
  class: "form-field"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Middle Initial:", -1))
const _hoisted_13 = { class: "form-field" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Last Name:", -1))
const _hoisted_15 = { class: "form-field" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Email:", -1))
const _hoisted_17 = {
  key: 1,
  class: "form-field"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "DOB:", -1))
const _hoisted_19 = { key: 2 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Category", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  selected: "",
  value: "Standard"
}, "Standard", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "Military" }, "Military", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "Student" }, "Student", -1))
const _hoisted_24 = [
  _hoisted_21,
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = { class: "form-field" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Phone:", -1))
const _hoisted_27 = { class: "row" }
const _hoisted_28 = /*#__PURE__*/_createStaticVNode("<option selected value=\"Mobile\" data-v-6af71f7e>Mobile</option><option value=\"Home\" data-v-6af71f7e>Home</option><option value=\"Work\" data-v-6af71f7e>Work</option><option value=\"Fax\" data-v-6af71f7e>Fax</option><option value=\"Pager\" data-v-6af71f7e>Pager</option><option value=\"Other\" data-v-6af71f7e>Other</option>", 6)
const _hoisted_34 = [
  _hoisted_28
]
const _hoisted_35 = { class: "form-field" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Address Line 1:", -1))
const _hoisted_37 = { class: "form-field" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Address Line 2:", -1))
const _hoisted_39 = { class: "form-field" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "City:", -1))
const _hoisted_41 = { class: "form-field" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "State/Province:", -1))
const _hoisted_43 = { class: "form-field" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Postal:", -1))
const _hoisted_45 = { class: "form-field" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Country:", -1))
const _hoisted_47 = { key: 1 }
const _hoisted_48 = { class: "form-field" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "First Name:", -1))
const _hoisted_50 = {
  key: 0,
  class: "form-field"
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Middle Initial:", -1))
const _hoisted_52 = { class: "form-field" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Last Name:", -1))
const _hoisted_54 = { class: "form-field" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Email:", -1))
const _hoisted_56 = {
  key: 1,
  class: "form-field"
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "DOB:", -1))
const _hoisted_58 = { key: 2 }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Category", -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  selected: "",
  value: "Standard"
}, "Standard", -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "Military" }, "Military", -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "Student" }, "Student", -1))
const _hoisted_63 = [
  _hoisted_60,
  _hoisted_61,
  _hoisted_62
]
const _hoisted_64 = { class: "form-field" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Phone:", -1))
const _hoisted_66 = ["onUpdate:modelValue"]
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { selected: "" }, "Mobile", -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Home", -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Work", -1))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Fax", -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Pager", -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Other", -1))
const _hoisted_73 = [
  _hoisted_67,
  _hoisted_68,
  _hoisted_69,
  _hoisted_70,
  _hoisted_71,
  _hoisted_72
]
const _hoisted_74 = ["onUpdate:modelValue"]
const _hoisted_75 = ["onUpdate:modelValue"]
const _hoisted_76 = ["onClick"]
const _hoisted_77 = { class: "form-field" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Address Line 1:", -1))
const _hoisted_79 = { class: "form-field" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Address Line 2:", -1))
const _hoisted_81 = { class: "form-field" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "City:", -1))
const _hoisted_83 = { class: "form-field" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "State/Province:", -1))
const _hoisted_85 = { class: "form-field" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Postal:", -1))
const _hoisted_87 = { class: "form-field" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Country:", -1))
const _hoisted_89 = {
  key: 4,
  class: "formField"
}
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Notes", -1))
const _hoisted_91 = { class: "box" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Personal Information", -1))
const _hoisted_93 = {
  key: 0,
  class: "form-field"
}
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Social Security Number", -1))
const _hoisted_95 = { class: "form-field" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Driver's license number:", -1))
const _hoisted_97 = {
  key: 0,
  class: "form-field"
}
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Driver's License State/Province:", -1))
const _hoisted_99 = {
  key: 1,
  class: "form-field"
}
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "License Plate Number:", -1))
const _hoisted_101 = {
  key: 2,
  class: "form-field"
}
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "License State/Province:", -1))
const _hoisted_103 = {
  key: 3,
  class: "form-field"
}
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Vehicle Description:", -1))
const _hoisted_105 = {
  key: 1,
  class: "form-field"
}
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "active_military" }, "Active Military", -1))
const _hoisted_107 = {
  key: 0,
  class: "box military"
}
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Military information", -1))
const _hoisted_109 = { class: "form-field" }
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Branch of service", -1))
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Air Force", -1))
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Army", -1))
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Coast Guard", -1))
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Marines", -1))
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Navy", -1))
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "National Guard", -1))
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Other", -1))
const _hoisted_118 = [
  _hoisted_111,
  _hoisted_112,
  _hoisted_113,
  _hoisted_114,
  _hoisted_115,
  _hoisted_116,
  _hoisted_117
]
const _hoisted_119 = { class: "form-field" }
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "retired_military" }, "Retired", -1))
const _hoisted_121 = { class: "form-field" }
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Place of Birth", -1))
const _hoisted_123 = ["disabled"]
const _hoisted_124 = { class: "form-field" }
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Military Email Address", -1))
const _hoisted_126 = ["disabled"]
const _hoisted_127 = { class: "form-field" }
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Last 4 of SSN", -1))
const _hoisted_129 = ["disabled"]
const _hoisted_130 = { class: "form-field" }
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Current Duty Location", -1))
const _hoisted_132 = ["disabled"]
const _hoisted_133 = { class: "form-field" }
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Military Rank", -1))
const _hoisted_135 = ["disabled"]
const _hoisted_136 = { class: "form-field" }
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Military Unit", -1))
const _hoisted_138 = ["disabled"]
const _hoisted_139 = { class: "form-field" }
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Squadron", -1))
const _hoisted_141 = ["disabled"]
const _hoisted_142 = { class: "form-field" }
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Division", -1))
const _hoisted_144 = ["disabled"]
const _hoisted_145 = { class: "form-field" }
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Type of Service", -1))
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Active Component", -1))
const _hoisted_148 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Reserve Component", -1))
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "National Guard", -1))
const _hoisted_150 = [
  _hoisted_147,
  _hoisted_148,
  _hoisted_149
]
const _hoisted_151 = { class: "form-field" }
const _hoisted_152 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Date Entered Service", -1))
const _hoisted_153 = { class: "form-field" }
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Military ID/Service ID", -1))
const _hoisted_155 = { class: "form-field" }
const _hoisted_156 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "End of Active Service Date", -1))
const _hoisted_157 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Commanding Officer Information", -1))
const _hoisted_158 = { class: "form-field" }
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "First Name", -1))
const _hoisted_160 = { class: "form-field" }
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Last Name", -1))
const _hoisted_162 = { class: "form-field" }
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Phone Number", -1))
const _hoisted_164 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Agent Information", -1))
const _hoisted_165 = { class: "form-field" }
const _hoisted_166 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "retired_military" }, "No Agent", -1))
const _hoisted_167 = { class: "form-field" }
const _hoisted_168 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "First Name", -1))
const _hoisted_169 = ["disabled"]
const _hoisted_170 = { class: "form-field" }
const _hoisted_171 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Last Name", -1))
const _hoisted_172 = ["disabled"]
const _hoisted_173 = { class: "form-field" }
const _hoisted_174 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Phone Number", -1))
const _hoisted_175 = ["disabled"]
const _hoisted_176 = { class: "form-field" }
const _hoisted_177 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Email", -1))
const _hoisted_178 = ["disabled"]
const _hoisted_179 = { class: "form-field" }
const _hoisted_180 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Address", -1))
const _hoisted_181 = ["disabled"]
const _hoisted_182 = { class: "form-field" }
const _hoisted_183 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "City", -1))
const _hoisted_184 = ["disabled"]
const _hoisted_185 = { class: "form-field" }
const _hoisted_186 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "State/Province", -1))
const _hoisted_187 = ["disabled"]
const _hoisted_188 = { class: "form-field" }
const _hoisted_189 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Postal", -1))
const _hoisted_190 = ["disabled"]
const _hoisted_191 = {
  key: 1,
  class: "box"
}
const _hoisted_192 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Alternate Contact Information", -1))
const _hoisted_193 = {
  key: 0,
  class: "form-field"
}
const _hoisted_194 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Description:", -1))
const _hoisted_195 = ["onUpdate:modelValue"]
const _hoisted_196 = { class: "form-field" }
const _hoisted_197 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "First Name:", -1))
const _hoisted_198 = ["onUpdate:modelValue"]
const _hoisted_199 = {
  key: 1,
  class: "form-field"
}
const _hoisted_200 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Middle initial:", -1))
const _hoisted_201 = ["onUpdate:modelValue"]
const _hoisted_202 = { class: "form-field" }
const _hoisted_203 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Last Name:", -1))
const _hoisted_204 = ["onUpdate:modelValue"]
const _hoisted_205 = {
  key: 2,
  class: "form-field"
}
const _hoisted_206 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Email:", -1))
const _hoisted_207 = ["onUpdate:modelValue"]
const _hoisted_208 = { class: "form-field" }
const _hoisted_209 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Phone Number:", -1))
const _hoisted_210 = ["onUpdate:modelValue"]
const _hoisted_211 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { selected: "" }, "Mobile", -1))
const _hoisted_212 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Home", -1))
const _hoisted_213 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Work", -1))
const _hoisted_214 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Fax", -1))
const _hoisted_215 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Pager", -1))
const _hoisted_216 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Other", -1))
const _hoisted_217 = [
  _hoisted_211,
  _hoisted_212,
  _hoisted_213,
  _hoisted_214,
  _hoisted_215,
  _hoisted_216
]
const _hoisted_218 = ["onUpdate:modelValue"]
const _hoisted_219 = ["onUpdate:modelValue"]
const _hoisted_220 = ["onClick"]
const _hoisted_221 = ["onClick"]
const _hoisted_222 = { class: "form-field" }
const _hoisted_223 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "address_line_1" }, "Address line 1:", -1))
const _hoisted_224 = ["onUpdate:modelValue"]
const _hoisted_225 = { class: "form-field" }
const _hoisted_226 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "address_line_2" }, "Address line 2:", -1))
const _hoisted_227 = ["onUpdate:modelValue"]
const _hoisted_228 = { class: "form-field" }
const _hoisted_229 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "city" }, "City:", -1))
const _hoisted_230 = ["onUpdate:modelValue"]
const _hoisted_231 = { class: "form-field" }
const _hoisted_232 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "state" }, "State/Province:", -1))
const _hoisted_233 = ["onUpdate:modelValue"]
const _hoisted_234 = { class: "form-field" }
const _hoisted_235 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "postal" }, "Postal:", -1))
const _hoisted_236 = ["onUpdate:modelValue"]
const _hoisted_237 = { class: "form-field" }
const _hoisted_238 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "country" }, "Country:", -1))
const _hoisted_239 = ["onUpdate:modelValue"]
const _hoisted_240 = { class: "form-field" }
const _hoisted_241 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "tax_exempt" }, "Tenant opt-in for Emails", -1))
const _hoisted_242 = { class: "form-field" }
const _hoisted_243 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "tax_exempt" }, "Tenant opt-in for SMS", -1))
const _hoisted_244 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Accounts & Access", -1))
const _hoisted_245 = { class: "form-field" }
const _hoisted_246 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "country" }, "Username:", -1))
const _hoisted_247 = { key: 0 }
const _hoisted_248 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_249 = { class: "form-field" }
const _hoisted_250 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "country" }, "Password:", -1))
const _hoisted_251 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Minimum of 6 digits required for password", -1))
const _hoisted_252 = {
  key: 0,
  class: "form-field"
}
const _hoisted_253 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "country" }, "Password Recovery Question:", -1))
const _hoisted_254 = {
  key: 1,
  class: "form-field"
}
const _hoisted_255 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "country" }, "Password Recovery Answer:", -1))
const _hoisted_256 = { key: 1 }
const _hoisted_257 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_258 = { key: 1 }
const _hoisted_259 = { key: 0 }
const _hoisted_260 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_261 = { key: 2 }
const _hoisted_262 = ["disabled"]
const _hoisted_263 = /*#__PURE__*/_createTextVNode(" Updating Customer ")
const _hoisted_264 = /*#__PURE__*/_createTextVNode(" Creating Customer ")
const _hoisted_265 = /*#__PURE__*/_createTextVNode(" Update Customer ")
const _hoisted_266 = /*#__PURE__*/_createTextVNode(" Create Customer ")
const _hoisted_267 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn"
}, "Cancel", -1))

import { useRouter } from "vue-router";
import { ref, watch } from "vue";
import BaseSpinner from "@/components/BaseSpinner.vue";

import api from "@virgodev/bazaar/functions/api";
import { ContactInterface, ContactAttributeInterface } from "@/types/customers";
// import { CustomerDataInterface } from "@/types/customers";
import { storeToRefs } from "pinia";
import { useStore } from "../../store";

export default /*#__PURE__*/_defineComponent({
  props: {
  customerId: {
    type: String,
    default: null,
  },
  rental: {
    type: Boolean,
    required: false,
    default: false,
  },
  unitId: {
    type: String,
    default: null,
    required: false,
  },
  facilityId: {
    type: String,
    default: null,
  },
},
  setup(__props) {

const props = __props

const store = useStore();
const { userData } = storeToRefs(store);
const router = useRouter();
const errors = ref("");
const status = ref("loading");

const formSubmitting = ref(false);
const formErrors = ref<Record<string, string[]>>({});
const api_settings = userData.value.chosenFacility.api_settings;
// const customer = ref<CustomerDataInterface>();
const tenantLeadId = ref();
const emailNotify = ref(true);
const accountType = ref(null);
const category = ref(null);
const account = ref(false);
const allowSignUp = ref(false);
const signUpErrors = ref(null);
const signUpSuccess = ref(null);
const formFields = ref({
  tenant_attributes: {
    first_name: ref(null),
    last_name: ref(null),
    middle_initial: ref(null),
    email: ref(null),
    is_business: ref(false),
    is_military: ref(false),
    social_security_number: ref(""),
    active_military: ref(false),
    notes: ref(""),
    dob: ref(),
    phone_numbers_attributes: [
      {
        label: ref(null),
        number: ref(null),
        extension: ref(null),
      },
    ],
    mailing_address_attributes: {
      address1: ref(null),
      address2: ref(null),
      city: ref(null),
      state: ref(null),
      postal: ref(null),
      country: ref(null),
    },
  },
  is_reservation: false,
  notes_attribute: [
    {
      notes: "",
    },
  ],
  caller_phone_attributes: {
    number: "+14351234567",
  },
  payment_method: {},
});
const formFieldsTenant = ref({
  first_name: ref(null),
  last_name: ref(null),
  dob: ref(),
  account_number: ref(null),
  middle_initial: ref(null),
  drivers_license_number: ref(null),
  drivers_license_state: ref(null),
  vehicle_license_plate_number: ref(null),
  vehicle_license_state: ref(null),
  vehicle_description: ref(null),
  social_security_number: ref(""),
  active_military: ref(false),
  notes: ref(""),
  email: ref(null),
  username: ref(null),
  password: ref(null),
  password_recovery_questions_attributes: [{ question: ref(), answer: ref() }],
  tax_exempt: ref(false),
  is_business: ref(false),
  is_military: ref(false),
  business_name: ref(null),
  title: ref(null),
  tenant_account_kind_name: ref("Standard"),
  decline_alternate_contact: ref(null),
  military_information: {
    retired_military: ref(false),
    no_agent_given: ref(false),
    date_entered_service: ref(null),
    military_id: ref(null),
    end_of_active_service_date: ref(null),
    place_of_birth: ref(null),
    last_4_of_ssn: ref(null),
    military_email_address: ref(null),
    military_rank: ref(null),
    current_duty_location: ref(null),
    branch_of_service: ref(null),
    military_unit: ref(null),
    squadron: ref(null),
    division: ref(null),
    type_of_service: ref(null),
    agent_first_name: ref(null),
    agent_last_name: ref(null),
    agent_email_address: ref(null),
    agent_phone_number: ref(null),
    agent_address: ref(null),
    agent_city: ref(null),
    agent_state: ref(null),
    agent_postal_code: ref(null),
    officer_first_name: ref(null),
    officer_last_name: ref(null),
    officer_phone_number: ref(null),
  },
  phone_numbers_attributes: [
    {
      label: ref(null),
      number: ref(null),
      extension: ref(null),
    },
  ],
  phone_numbers: [
    {
      id: ref(null),
      label: ref(null),
      number: ref(null),
      extension: ref(null),
    },
  ],
  mailing_address_attributes: {
    address1: ref(null),
    address2: ref(null),
    city: ref(null),
    state: ref(null),
    postal: ref(null),
    country: ref(null),
  },
  mailing_address: {
    address1: ref(null),
    address2: ref(null),
    city: ref(null),
    state: ref(null),
    postal: ref(null),
    country: ref(null),
  },
  contacts: ref(Array<ContactInterface>()),
  contacts_attributes: ref(Array<ContactAttributeInterface>()),
  sms_opt: ref(),
  web_password: ref(),
  access_code: ref(),
});



function addNumber() {
  formFieldsTenant.value.phone_numbers.push({
    id: null,
    label: null,
    number: null,
    extension: null,
  });
}
function addContactNumber(contact: ContactInterface) {
  let index = formFieldsTenant.value.contacts.findIndex(function (item) {
    return item === contact;
  });
  if (index != -1) {
    formFieldsTenant.value.contacts[index].phone_numbers.push({
      id: "",
      label: "",
      number: "",
      extension: "",
    });
  }
}

function removeNumber(obj: {
  id: null;
  label: null;
  number: null;
  extension: null;
}) {
  let index = formFieldsTenant.value.phone_numbers.findIndex(function (item) {
    return item === obj;
  });

  if (index != -1) {
    formFieldsTenant.value.phone_numbers.splice(index, 1);
  }
}
function removeContactNumber(
  obj: { id: string; number: string; extension: string; label: string },
  contact: ContactInterface
) {
  let indexContact = formFieldsTenant.value.contacts.findIndex(function (item) {
    return item === contact;
  });
  if (indexContact != -1) {
    let index = formFieldsTenant.value.contacts[
      indexContact
    ].phone_numbers.findIndex(function (item) {
      return item === obj;
    });

    if (index != -1) {
      formFieldsTenant.value.contacts[indexContact].phone_numbers.splice(
        index,
        1
      );
    }
  }
}

function updateCategory() {
  if (
    formFieldsTenant.value.tenant_account_kind_name == "Military" ||
    category.value == "Military"
  ) {
    formFieldsTenant.value.is_military = true;
  } else {
    formFieldsTenant.value.is_military = false;
  }
}
async function getCustomer() {
  errors.value = "";
  const response = await api({
    url: `customers/?id=${props.customerId}&facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    formFieldsTenant.value = response.body[0];
    if (response.body[0].username) {
      account.value = true;
    }
    if (api_settings.security_questions) {
      if (!formFieldsTenant.value.password_recovery_questions_attributes) {
        formFieldsTenant.value.password_recovery_questions_attributes = [
          {
            question: ref(),
            answer: ref(),
          },
        ];
      }
    } else {
      formFieldsTenant.value.access_code = response.body[0].access_code;
      if (formFieldsTenant.value.web_password) {
        account.value = true;
      }
    }

    if (formFieldsTenant.value.phone_numbers.length == 0) {
      formFieldsTenant.value.phone_numbers = [
        {
          id: null,
          label: null,
          number: null,
          extension: null,
        },
      ];
    }
    if (!formFieldsTenant.value.mailing_address) {
      formFieldsTenant.value.mailing_address = {
        address1: null,
        address2: null,
        city: null,
        state: null,
        postal: null,
        country: null,
      };
    }

    if (
      !formFieldsTenant.value.contacts ||
      formFieldsTenant.value.contacts.length == 0
    ) {
      formFieldsTenant.value.contacts = [];
      formFieldsTenant.value.contacts.push({
        id: "",
        description: "",
        first_name: "",
        middle_initial: "",
        last_name: "",
        email: "",
        phone_numbers: [
          {
            id: "",
            number: "",
            extension: "",
            label: "",
          },
        ],
        address: {
          address1: "",
          address2: "",
          city: "",
          state: "",
          postal: "",
          country: "",
        },
      });
    }
    if (!formFieldsTenant.value.military_information) {
      formFieldsTenant.value.military_information = {
        retired_military: false,
        no_agent_given: false,
        date_entered_service: null,
        military_id: null,
        end_of_active_service_date: null,
        place_of_birth: null,
        last_4_of_ssn: null,
        military_email_address: null,
        military_rank: null,
        current_duty_location: null,
        branch_of_service: null,
        military_unit: null,
        squadron: null,
        division: null,
        type_of_service: null,
        agent_first_name: null,
        agent_last_name: null,
        agent_email_address: null,
        agent_phone_number: null,
        agent_address: null,
        agent_city: null,
        agent_state: null,
        agent_postal_code: null,
        officer_first_name: null,
        officer_last_name: null,
        officer_phone_number: null,
      };
    }
    if (api_settings.other_tenant_info && response.body.is_military) {
      formFieldsTenant.value.military_information.retired_military = JSON.parse(
        response.body.military_information.retired_military
      );
      formFieldsTenant.value.military_information.no_agent_given = JSON.parse(
        response.body.military_information.no_agent_given
      );
    }
    // await getUserInfo();
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
  status.value = "loaded";
}
async function submitForm() {
  formSubmitting.value = true;
  if (!props.customerId) {
    const existingLead = await findDuplicateLead();
    if (existingLead) {
      formErrors.value = {
        server_error: [
          "A lead already exists for this contact. Please use the existing lead to proceed.",
        ],
      };
      formSubmitting.value = false;
      return;
    }
  }
  if (api_settings.tenant_lead_required) {
    if (accountType.value == "business") {
      if (props.customerId) {
        formFieldsTenant.value.is_business = true;
      } else {
        formFields.value.tenant_attributes.is_business = true;
      }
    }
    let json_tenant;
    let json_lead;
    if (category.value == "military") {
      if (props.customerId) {
        formFieldsTenant.value.is_military = true;
      } else {
        formFields.value.tenant_attributes.is_military = true;
      }
    }
    formFieldsTenant.value.phone_numbers_attributes =
      formFieldsTenant.value.phone_numbers;
    formFieldsTenant.value.mailing_address_attributes =
      formFieldsTenant.value.mailing_address;
    if (!formFieldsTenant.value.contacts_attributes) {
      formFieldsTenant.value.contacts_attributes = [];
    }
    for (let contact of formFieldsTenant.value.contacts) {
      if (contact.description && contact.first_name) {
        let contactId: string | null = contact.id;
        if (!contactId) {
          contactId = null;
        }
        formFieldsTenant.value.contacts_attributes.push({
          id: contactId,
          description: contact.description,
          first_name: contact.first_name,
          middle_initial: contact.middle_initial,
          last_name: contact.last_name,
          email: contact.email,
          phone_numbers_attributes: contact.phone_numbers,
          address_attributes: contact.address,
        });
      }
    }

    json_tenant = JSON.parse(JSON.stringify(formFieldsTenant.value));
    delete json_tenant.phone_numbers;
    delete json_tenant.mailing_address;
    delete json_tenant.contacts;

    json_lead = JSON.parse(JSON.stringify(formFields.value));
    if (!api_settings.tenant_dob) {
      delete json_lead.tenant_attributes.dob;
      delete json_tenant.dob;
    }
    if (!api_settings.social_security) {
      delete json_tenant.social_security_number;
      delete json_lead.social_security_number;
    }
    if (!api_settings.military_checkbox) {
      delete json_tenant.active_military;
      delete json_lead.active_military;
    }
    if (!api_settings.tenant_notes) {
      delete json_tenant.notes;
      delete json_lead.notes;
    }

    formErrors.value = {};
    if (!props.customerId && !tenantLeadId.value) {
      if (api_settings.license_with_lead) {
        json_lead.tenant_attributes.drivers_license_number =
          formFieldsTenant.value.drivers_license_number;
      }
      const responseData = await api({
        url: `leads/?facilityId=${props.facilityId}`,
        method: "POST",
        json: json_lead,
      });
      if ([200, 201].includes(responseData.status)) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        tenantLeadId.value = responseData.body.lead.tenant_id;
        if (!api_settings.lead_to_tenant_sign_up && !props.customerId) {
          if (props.rental === true && tenantLeadId.value) {
            router.push({
              name: "rental_storedge",
              params: {
                customerId: tenantLeadId.value,
                facilityId: props.facilityId,
              },
            });
          } else if (props.unitId && tenantLeadId) {
            router.push({
              name: "rental_storedge",
              params: {
                unitId: props.unitId,
                customerId: tenantLeadId.value,
                facilityId: props.facilityId,
              },
            });
          } else {
            router.push({
              name: "customer_detail_storedge",
              params: {
                id: tenantLeadId.value,
                facilityId: props.facilityId,
              },
            });
          }
        }
      } else if (responseData.status === 400) {
        formErrors.value = { server_error: [responseData.body.meta.message] };
        formSubmitting.value = false;
      }
    }
    let url = `customer/?facilityId=${props.facilityId}`;

    if (props.customerId) {
      url += `&id=${props.customerId}`;
      if (account.value) {
        delete json_tenant.password_recovery_questions_attributes;
        if (!allowSignUp.value) {
          delete json_tenant.password;
        }
      }
    } else if (tenantLeadId.value) {
      url += `&id=${tenantLeadId.value}`;

      json_tenant.first_name = json_lead.tenant_attributes.first_name;
      json_tenant.last_name = json_lead.tenant_attributes.last_name;
      json_tenant.middle_initial = json_lead.tenant_attributes.middle_initial;
      json_tenant.email = json_lead.tenant_attributes.email;
    }
    if (account.value) {
      delete json_tenant.password_recovery_questions_attributes;
      if (!allowSignUp.value) {
        delete json_tenant.password;
      }
    } else if (
      (!json_tenant.username && !json_tenant.password) ||
      (json_tenant.username &&
        json_lead.password &&
        !json_tenant.password_recovery_questions_attributes)
    ) {
      delete json_tenant.password_recovery_questions_attributes;
    }
    if (props.customerId || (!props.customerId && tenantLeadId.value)) {
      if (api_settings.lead_to_tenant_sign_up || props.customerId) {
        const responseData = await api({
          url,
          method: "PATCH",
          json: json_tenant,
        });

        if ([200, 201].includes(responseData.status)) {
          let customerId = props.customerId;

          if (!props.customerId && tenantLeadId.value) {
            customerId = tenantLeadId.value;
          }
          let signingUp = false;
          if (
            (!account.value || allowSignUp.value) &&
            json_tenant.username &&
            json_tenant.password
          ) {
            signingUp = true;
            signUpErrors.value = null;
            signUpSuccess.value = null;
            const signUpResponse = await api({
              url: `customer_sign_up/?facilityId=${props.facilityId}&id=${customerId}`,
              method: "POST",
              json: json_tenant,
            });
            if (signUpResponse.status === 200) {
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              signUpSuccess.value = signUpResponse.body;
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
            } else if (signUpResponse.body.meta.message) {
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              signUpErrors.value = signUpResponse.body.meta.message;
              formSubmitting.value = false;
            }
          }
          if (!signingUp || (signingUp && !signUpErrors.value)) {
            if (props.rental == true && tenantLeadId.value) {
              router.push({
                name: "rental_storedge",
                params: {
                  customerId: tenantLeadId.value,
                  facilityId: props.facilityId,
                },
              });
            } else if (props.unitId && customerId) {
              router.push({
                name: "rental_storedge",
                params: {
                  unitId: props.unitId,
                  customerId: tenantLeadId.value,
                  facilityId: props.facilityId,
                },
              });
            } else if (customerId) {
              router.push({
                name: "customer_detail_storedge",
                params: {
                  id: customerId,
                  facilityId: props.facilityId,
                },
              });
            }
          }
        } else if (responseData.status === 400) {
          formErrors.value = { server_error: [responseData.body.meta.message] };
          formSubmitting.value = false;
        } else {
          formErrors.value = {
            non_field_errors: [
              "Unable to communicate with the server. Please check your " +
                "connection and try again.",
            ],
          };
        }
      }
    }
  } else {
    let json_tenant;
    let url = `customer/?facilityId=${props.facilityId}`;
    if (!props.customerId) {
      json_tenant = JSON.parse(
        JSON.stringify({
          ...formFields.value.tenant_attributes,
          ...formFieldsTenant.value.mailing_address,
          ...formFieldsTenant.value.phone_numbers,
          drivers_license_number: formFieldsTenant.value.drivers_license_number,
          drivers_license_state: formFieldsTenant.value.drivers_license_state,
          contacts_attributes: formFieldsTenant.value.contacts,
          password: formFieldsTenant.value.password,
          social_security_number: formFieldsTenant.value.social_security_number,
          active_military: formFieldsTenant.value.active_military,
          notes: formFieldsTenant.value.notes,
        })
      );
    } else {
      url += "&id=" + props.customerId;
      json_tenant = JSON.parse(JSON.stringify(formFieldsTenant.value));
    }
    if (api_settings.sms_and_email_opt_in) {
      json_tenant.email_opt = emailNotify.value;
      json_tenant.sms_opt = formFieldsTenant.value.sms_opt;
    }
    const response = await api({
      url: url,
      method: "POST",
      json: json_tenant,
    });
    if (response.status === 200) {
      let new_tenant = response.body;
      if (response.body.length) {
        new_tenant = response.body[0];
      }
      if (props.unitId) {
        router.push({
          name: "rental_storedge",
          params: {
            unitId: props.unitId,
            customerId: new_tenant.id,
            facilityId: props.facilityId,
          },
        });
      } else {
        if (!new_tenant.id) {
          new_tenant = { id: props.customerId };
        }
        router.push({
          name: "customer_detail_storedge",
          params: {
            id: new_tenant.id,
            facilityId: props.facilityId,
          },
        });
      }
    } else if (response.status === 400) {
      formErrors.value = { server_error: [response.body.error] };
    } else {
      formErrors.value = {
        non_field_errors: [
          "Unable to communicate with the server. Please check your " +
            "connection and try again.",
        ],
      };
    }
    formSubmitting.value = false;
  }
}
if (props.customerId) {
  getCustomer();
} else {
  if (api_settings.sms_and_email_opt_in) {
    formFieldsTenant.value.sms_opt = true;
  }
  status.value = "loaded";
  if (
    !formFieldsTenant.value.contacts ||
    formFieldsTenant.value.contacts.length == 0
  ) {
    formFieldsTenant.value.contacts.push({
      id: "",
      description: "",
      first_name: "",
      middle_initial: "",
      last_name: "",
      email: "",
      phone_numbers: [
        {
          id: "",
          number: "",
          extension: "",
          label: "",
        },
      ],
      address: {
        address1: "",
        address2: "",
        city: "",
        state: "",
        postal: "",
        country: "",
      },
    });
  }
}

watch(
  () => props.customerId,
  (id) => {
    if (id) {
      status.value = "loading";
      getCustomer();
    }
  }
);

function unwrap(val: unknown): string | null {
  if (
    val &&
    typeof val === "object" &&
    "value" in (val as Record<string, unknown>)
  ) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return (val as { value: string | null }).value || null;
  }
  if (val === undefined || val === null) return null;
  return String(val);
}
function stripDigits(val: string | null): string {
  return val ? val.replace(/\D/g, "") : "";
}
async function findDuplicateLead() {
  const emails = new Set<string>();
  const phones = new Set<string>();

  const candidateEmails = [
    unwrap(formFieldsTenant.value.email),
    unwrap(formFields.value.tenant_attributes.email),
  ].filter(Boolean) as string[];
  candidateEmails.forEach((email) => emails.add(email.trim().toLowerCase()));

  const candidatePhones = [
    unwrap(formFieldsTenant.value.phone_numbers?.[0]?.number || null),
    unwrap(
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      formFields.value.tenant_attributes.phone_numbers_attributes?.[0]
        ?.number || null
    ),
  ].filter(Boolean) as string[];
  candidatePhones.forEach((p) => {
    const digits = stripDigits(p);
    if (digits) phones.add(digits);
  });

  if (!emails.size && !phones.size) return null;

  const response = await api({
    url: `aggregate_leads/?facilityIds=${props.facilityId || ""}`,
  });
  if (![200, 207].includes(response.status) || !("body" in response)) {
    return null;
  }
  const body: Record<string, unknown> =
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    response.body || {};
  const results = Array.isArray((body as { results?: [] }).results)
    ? (body as { results: [] }).results
    : [];
  const leads = results.flatMap((item: { leads?: [] }) => item.leads || []);

  for (const lead of leads) {
    const leadEmail = (lead as Record<string, unknown>).email;
    if (leadEmail && typeof leadEmail === "string") {
      if (emails.has(leadEmail.trim().toLowerCase())) return lead;
    }
    const nums = ((lead as Record<string, unknown>).phone_numbers ||
      []) as Array<Record<string, unknown>>;
    for (const entry of nums) {
      const num = entry.unformatted_number || entry.formatted_number;
      if (typeof num === "string") {
        const digits = stripDigits(num);
        if (digits && phones.has(digits)) return lead;
      }
    }
  }
  return null;
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_BaseAlert = _resolveComponent("BaseAlert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.customerId)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("h1", null, " Edit " + _toDisplayString(formFieldsTenant.value.first_name) + " " + _toDisplayString(formFieldsTenant.value.last_name), 1)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4)),
    (status.value === 'loading')
      ? (_openBlock(), _createBlock(BaseSpinner, {
          key: 2,
          preset: "large"
        }))
      : (status.value === 'loaded')
        ? (_openBlock(), _createElementBlock("form", {
            key: 3,
            class: "larger-width-centered",
            enctype: "multipart/form-data",
            onSubmit: _withModifiers(submitForm, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              (!__props.customerId)
                ? (_openBlock(), _createElementBlock("fieldset", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formFields.value.tenant_attributes.first_name) = $event)),
                        type: "text",
                        required: ""
                      }, null, 512), [
                        [_vModelText, formFields.value.tenant_attributes.first_name]
                      ])
                    ]),
                    (_unref(api_settings).middle_initial)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _hoisted_12,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formFields.value.tenant_attributes.middle_initial) = $event)),
                            type: "text"
                          }, null, 512), [
                            [_vModelText, formFields.value.tenant_attributes.middle_initial]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formFields.value.tenant_attributes.last_name) = $event)),
                        type: "text",
                        required: ""
                      }, null, 512), [
                        [_vModelText, formFields.value.tenant_attributes.last_name]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formFields.value.tenant_attributes.email) = $event)),
                        type: "text",
                        required: ""
                      }, null, 512), [
                        [_vModelText, formFields.value.tenant_attributes.email]
                      ])
                    ]),
                    (_unref(api_settings).tenant_dob)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _hoisted_18,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formFields.value.tenant_attributes.dob) = $event)),
                            type: "date",
                            required: ""
                          }, null, 512), [
                            [_vModelText, formFields.value.tenant_attributes.dob]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(api_settings).military_information)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _hoisted_20,
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((category).value = $event)),
                            class: "form-select",
                            onChange: updateCategory
                          }, _hoisted_24, 544), [
                            [_vModelSelect, category.value]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_25, [
                      _hoisted_26,
                      _createElementVNode("div", _hoisted_27, [
                        (_unref(api_settings).phone_numbers_attributes_label)
                          ? _withDirectives((_openBlock(), _createElementBlock("select", {
                              key: 0,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((
                formFields.value.tenant_attributes.phone_numbers_attributes[0].label
              ) = $event)),
                              class: "form-select"
                            }, _hoisted_34, 512)), [
                              [_vModelSelect, 
                formFields.value.tenant_attributes.phone_numbers_attributes[0].label
              ]
                            ])
                          : _createCommentVNode("", true),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((
                formFields.value.tenant_attributes.phone_numbers_attributes[0].number
              ) = $event)),
                          class: "form-field",
                          type: "text",
                          placeholder: "phone number"
                        }, null, 512), [
                          [_vModelText, 
                formFields.value.tenant_attributes.phone_numbers_attributes[0].number
              ]
                        ]),
                        (_unref(api_settings).phone_numbers_attributes_extension)
                          ? _withDirectives((_openBlock(), _createElementBlock("input", {
                              key: 1,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((
                formFields.value.tenant_attributes.phone_numbers_attributes[0]
                  .extension
              ) = $event)),
                              class: "form-field",
                              type: "text",
                              placeholder: "extension"
                            }, null, 512)), [
                              [_vModelText, 
                formFields.value.tenant_attributes.phone_numbers_attributes[0]
                  .extension
              ]
                            ])
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _hoisted_36,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((
              formFields.value.tenant_attributes.mailing_address_attributes.address1
            ) = $event)),
                        type: "text"
                      }, null, 512), [
                        [_vModelText, 
              formFields.value.tenant_attributes.mailing_address_attributes.address1
            ]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _hoisted_38,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((
              formFields.value.tenant_attributes.mailing_address_attributes.address2
            ) = $event)),
                        type: "text"
                      }, null, 512), [
                        [_vModelText, 
              formFields.value.tenant_attributes.mailing_address_attributes.address2
            ]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      _hoisted_40,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((
              formFields.value.tenant_attributes.mailing_address_attributes.city
            ) = $event)),
                        type: "text"
                      }, null, 512), [
                        [_vModelText, 
              formFields.value.tenant_attributes.mailing_address_attributes.city
            ]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _hoisted_42,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((
              formFields.value.tenant_attributes.mailing_address_attributes.state
            ) = $event)),
                        type: "text"
                      }, null, 512), [
                        [_vModelText, 
              formFields.value.tenant_attributes.mailing_address_attributes.state
            ]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_43, [
                      _hoisted_44,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((
              formFields.value.tenant_attributes.mailing_address_attributes.postal
            ) = $event)),
                        type: "text"
                      }, null, 512), [
                        [_vModelText, 
              formFields.value.tenant_attributes.mailing_address_attributes.postal
            ]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                      _hoisted_46,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((
              formFields.value.tenant_attributes.mailing_address_attributes.country
            ) = $event)),
                        type: "text"
                      }, null, 512), [
                        [_vModelText, 
              formFields.value.tenant_attributes.mailing_address_attributes.country
            ]
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("fieldset", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _hoisted_49,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((formFieldsTenant.value.first_name) = $event)),
                        type: "text",
                        required: ""
                      }, null, 512), [
                        [_vModelText, formFieldsTenant.value.first_name]
                      ])
                    ]),
                    (_unref(api_settings).middle_initial)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                          _hoisted_51,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((formFieldsTenant.value.middle_initial) = $event)),
                            type: "text"
                          }, null, 512), [
                            [_vModelText, formFieldsTenant.value.middle_initial]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_52, [
                      _hoisted_53,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((formFieldsTenant.value.last_name) = $event)),
                        type: "text",
                        required: ""
                      }, null, 512), [
                        [_vModelText, formFieldsTenant.value.last_name]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_54, [
                      _hoisted_55,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((formFieldsTenant.value.email) = $event)),
                        type: "text",
                        required: ""
                      }, null, 512), [
                        [_vModelText, formFieldsTenant.value.email]
                      ])
                    ]),
                    (_unref(api_settings).tenant_dob)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                          _hoisted_57,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((formFieldsTenant.value.dob) = $event)),
                            type: "date",
                            required: ""
                          }, null, 512), [
                            [_vModelText, formFieldsTenant.value.dob]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(api_settings).tenant_account_kind_name)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                          _hoisted_59,
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((formFieldsTenant.value.tenant_account_kind_name) = $event)),
                            class: "form-select",
                            onChange: updateCategory
                          }, _hoisted_63, 544), [
                            [_vModelSelect, formFieldsTenant.value.tenant_account_kind_name]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_64, [
                      _hoisted_65,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formFieldsTenant.value.phone_numbers, (number) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: number.id + 'number',
                          class: "row"
                        }, [
                          (_unref(api_settings).alternate_contact_phone_label)
                            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                key: 0,
                                "onUpdate:modelValue": ($event: any) => ((number.label) = $event),
                                class: "form-select"
                              }, _hoisted_73, 8, _hoisted_66)), [
                                [_vModelSelect, number.label]
                              ])
                            : _createCommentVNode("", true),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((number.number) = $event),
                            class: "form-field",
                            type: "text",
                            placeholder: "primary number"
                          }, null, 8, _hoisted_74), [
                            [_vModelText, number.number]
                          ]),
                          (_unref(api_settings).alternate_contact_phone_extension)
                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 1,
                                "onUpdate:modelValue": ($event: any) => ((number.extension) = $event),
                                class: "form-field",
                                type: "text",
                                placeholder: "extension"
                              }, null, 8, _hoisted_75)), [
                                [_vModelText, number.extension]
                              ])
                            : _createCommentVNode("", true),
                          (
                formFieldsTenant.value.phone_numbers.length > 1 &&
                _unref(api_settings).alternate_contact_multiple
              )
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 2,
                                class: "btn btn-text",
                                onClick: ($event: any) => (removeNumber(number))
                              }, " Remove ", 8, _hoisted_76))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]),
                    (_unref(api_settings).alternate_contact_multiple)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 3,
                          class: "btn btn-text",
                          onClick: _cache[21] || (_cache[21] = ($event: any) => (addNumber()))
                        }, " Add number "))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_77, [
                      _hoisted_78,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((formFieldsTenant.value.mailing_address.address1) = $event)),
                        type: "text"
                      }, null, 512), [
                        [_vModelText, formFieldsTenant.value.mailing_address.address1]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_79, [
                      _hoisted_80,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((formFieldsTenant.value.mailing_address.address2) = $event)),
                        type: "text"
                      }, null, 512), [
                        [_vModelText, formFieldsTenant.value.mailing_address.address2]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_81, [
                      _hoisted_82,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((formFieldsTenant.value.mailing_address.city) = $event)),
                        type: "text"
                      }, null, 512), [
                        [_vModelText, formFieldsTenant.value.mailing_address.city]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_83, [
                      _hoisted_84,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((formFieldsTenant.value.mailing_address.state) = $event)),
                        type: "text"
                      }, null, 512), [
                        [_vModelText, formFieldsTenant.value.mailing_address.state]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_85, [
                      _hoisted_86,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((formFieldsTenant.value.mailing_address.postal) = $event)),
                        type: "text"
                      }, null, 512), [
                        [_vModelText, formFieldsTenant.value.mailing_address.postal]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_87, [
                      _hoisted_88,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((formFieldsTenant.value.mailing_address.country) = $event)),
                        type: "text"
                      }, null, 512), [
                        [_vModelText, formFieldsTenant.value.mailing_address.country]
                      ])
                    ]),
                    (_unref(api_settings).tenant_notes)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                          _hoisted_90,
                          _withDirectives(_createElementVNode("textarea", {
                            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((formFieldsTenant.value.notes) = $event))
                          }, null, 512), [
                            [_vModelText, formFieldsTenant.value.notes]
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
            ]),
            _createElementVNode("div", _hoisted_91, [
              _hoisted_92,
              _createElementVNode("fieldset", null, [
                (_unref(api_settings).social_security)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                      _hoisted_94,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((formFieldsTenant.value.social_security_number) = $event)),
                        type: "text"
                      }, null, 512), [
                        [_vModelText, formFieldsTenant.value.social_security_number]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_95, [
                    _hoisted_96,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((formFieldsTenant.value.drivers_license_number) = $event)),
                      type: "text"
                    }, null, 512), [
                      [_vModelText, formFieldsTenant.value.drivers_license_number]
                    ])
                  ]),
                  (_unref(api_settings).driver_state)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                        _hoisted_98,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((formFieldsTenant.value.drivers_license_state) = $event)),
                          type: "text"
                        }, null, 512), [
                          [_vModelText, formFieldsTenant.value.drivers_license_state]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(api_settings).vehicle_license_plate_number)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                        _hoisted_100,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((formFieldsTenant.value.vehicle_license_plate_number) = $event)),
                          type: "text"
                        }, null, 512), [
                          [_vModelText, formFieldsTenant.value.vehicle_license_plate_number]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(api_settings).vehicle_license_state)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                        _hoisted_102,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((formFieldsTenant.value.vehicle_license_state) = $event)),
                          type: "text"
                        }, null, 512), [
                          [_vModelText, formFieldsTenant.value.vehicle_license_state]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(api_settings).vehicle_description)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                        _hoisted_104,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((formFieldsTenant.value.vehicle_description) = $event)),
                          type: "text"
                        }, null, 512), [
                          [_vModelText, formFieldsTenant.value.vehicle_description]
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_unref(api_settings).military_checkbox)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((formFieldsTenant.value.active_military) = $event)),
                        type: "checkbox"
                      }, null, 512), [
                        [_vModelCheckbox, formFieldsTenant.value.active_military]
                      ]),
                      _hoisted_106
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (formFieldsTenant.value.is_military)
              ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                  _hoisted_108,
                  _createElementVNode("fieldset", null, [
                    _createElementVNode("div", _hoisted_109, [
                      _hoisted_110,
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((formFieldsTenant.value.military_information.branch_of_service) = $event)),
                        class: "form-select"
                      }, _hoisted_118, 512), [
                        [_vModelSelect, formFieldsTenant.value.military_information.branch_of_service]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_119, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((formFieldsTenant.value.military_information.retired_military) = $event)),
                        type: "checkbox"
                      }, null, 512), [
                        [_vModelCheckbox, formFieldsTenant.value.military_information.retired_military]
                      ]),
                      _hoisted_120
                    ]),
                    _createElementVNode("div", _hoisted_121, [
                      _hoisted_122,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((formFieldsTenant.value.military_information.place_of_birth) = $event)),
                        type: "text",
                        disabled: formFieldsTenant.value.military_information.retired_military
                      }, null, 8, _hoisted_123), [
                        [_vModelText, formFieldsTenant.value.military_information.place_of_birth]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_124, [
                      _hoisted_125,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((
              formFieldsTenant.value.military_information.military_email_address
            ) = $event)),
                        type: "text",
                        disabled: formFieldsTenant.value.military_information.retired_military
                      }, null, 8, _hoisted_126), [
                        [_vModelText, 
              formFieldsTenant.value.military_information.military_email_address
            ]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_127, [
                      _hoisted_128,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((formFieldsTenant.value.military_information.last_4_of_ssn) = $event)),
                        type: "text",
                        disabled: formFieldsTenant.value.military_information.retired_military
                      }, null, 8, _hoisted_129), [
                        [_vModelText, formFieldsTenant.value.military_information.last_4_of_ssn]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_130, [
                      _hoisted_131,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((
              formFieldsTenant.value.military_information.current_duty_location
            ) = $event)),
                        type: "text",
                        disabled: formFieldsTenant.value.military_information.retired_military
                      }, null, 8, _hoisted_132), [
                        [_vModelText, 
              formFieldsTenant.value.military_information.current_duty_location
            ]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_133, [
                      _hoisted_134,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((formFieldsTenant.value.military_information.military_rank) = $event)),
                        type: "text",
                        disabled: formFieldsTenant.value.military_information.retired_military
                      }, null, 8, _hoisted_135), [
                        [_vModelText, formFieldsTenant.value.military_information.military_rank]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_136, [
                      _hoisted_137,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((formFieldsTenant.value.military_information.military_unit) = $event)),
                        type: "text",
                        disabled: formFieldsTenant.value.military_information.retired_military
                      }, null, 8, _hoisted_138), [
                        [_vModelText, formFieldsTenant.value.military_information.military_unit]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_139, [
                      _hoisted_140,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((formFieldsTenant.value.military_information.squadron) = $event)),
                        type: "text",
                        disabled: formFieldsTenant.value.military_information.retired_military
                      }, null, 8, _hoisted_141), [
                        [_vModelText, formFieldsTenant.value.military_information.squadron]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_142, [
                      _hoisted_143,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((formFieldsTenant.value.military_information.division) = $event)),
                        type: "text",
                        disabled: formFieldsTenant.value.military_information.retired_military
                      }, null, 8, _hoisted_144), [
                        [_vModelText, formFieldsTenant.value.military_information.division]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_145, [
                      _hoisted_146,
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((formFieldsTenant.value.military_information.type_of_service) = $event)),
                        class: "form-select"
                      }, _hoisted_150, 512), [
                        [_vModelSelect, formFieldsTenant.value.military_information.type_of_service]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_151, [
                      _hoisted_152,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((formFieldsTenant.value.military_information.date_entered_service) = $event)),
                        type: "date"
                      }, null, 512), [
                        [_vModelText, formFieldsTenant.value.military_information.date_entered_service]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_153, [
                      _hoisted_154,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((formFieldsTenant.value.military_information.military_id) = $event)),
                        type: "text"
                      }, null, 512), [
                        [_vModelText, formFieldsTenant.value.military_information.military_id]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_155, [
                      _hoisted_156,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((
              formFieldsTenant.value.military_information.end_of_active_service_date
            ) = $event)),
                        type: "date"
                      }, null, 512), [
                        [_vModelText, 
              formFieldsTenant.value.military_information.end_of_active_service_date
            ]
                      ])
                    ]),
                    _hoisted_157,
                    _createElementVNode("div", _hoisted_158, [
                      _hoisted_159,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((formFieldsTenant.value.military_information.officer_first_name) = $event)),
                        type: "text"
                      }, null, 512), [
                        [_vModelText, formFieldsTenant.value.military_information.officer_first_name]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_160, [
                      _hoisted_161,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((formFieldsTenant.value.military_information.officer_last_name) = $event)),
                        type: "text"
                      }, null, 512), [
                        [_vModelText, formFieldsTenant.value.military_information.officer_last_name]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_162, [
                      _hoisted_163,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((formFieldsTenant.value.military_information.officer_phone_number) = $event)),
                        type: "text"
                      }, null, 512), [
                        [_vModelText, formFieldsTenant.value.military_information.officer_phone_number]
                      ])
                    ]),
                    _hoisted_164,
                    _createElementVNode("div", _hoisted_165, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((formFieldsTenant.value.military_information.no_agent_given) = $event)),
                        type: "checkbox"
                      }, null, 512), [
                        [_vModelCheckbox, formFieldsTenant.value.military_information.no_agent_given]
                      ]),
                      _hoisted_166
                    ]),
                    _createElementVNode("div", _hoisted_167, [
                      _hoisted_168,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((formFieldsTenant.value.military_information.agent_first_name) = $event)),
                        type: "text",
                        disabled: formFieldsTenant.value.military_information.no_agent_given
                      }, null, 8, _hoisted_169), [
                        [_vModelText, formFieldsTenant.value.military_information.agent_first_name]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_170, [
                      _hoisted_171,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((formFieldsTenant.value.military_information.agent_last_name) = $event)),
                        type: "text",
                        disabled: formFieldsTenant.value.military_information.no_agent_given
                      }, null, 8, _hoisted_172), [
                        [_vModelText, formFieldsTenant.value.military_information.agent_last_name]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_173, [
                      _hoisted_174,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((formFieldsTenant.value.military_information.agent_phone_number) = $event)),
                        type: "text",
                        disabled: formFieldsTenant.value.military_information.no_agent_given
                      }, null, 8, _hoisted_175), [
                        [_vModelText, formFieldsTenant.value.military_information.agent_phone_number]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_176, [
                      _hoisted_177,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((formFieldsTenant.value.military_information.agent_email_address) = $event)),
                        type: "text",
                        disabled: formFieldsTenant.value.military_information.no_agent_given
                      }, null, 8, _hoisted_178), [
                        [_vModelText, formFieldsTenant.value.military_information.agent_email_address]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_179, [
                      _hoisted_180,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((formFieldsTenant.value.military_information.agent_address) = $event)),
                        type: "text",
                        disabled: formFieldsTenant.value.military_information.no_agent_given
                      }, null, 8, _hoisted_181), [
                        [_vModelText, formFieldsTenant.value.military_information.agent_address]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_182, [
                      _hoisted_183,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((formFieldsTenant.value.military_information.agent_city) = $event)),
                        type: "text",
                        disabled: formFieldsTenant.value.military_information.no_agent_given
                      }, null, 8, _hoisted_184), [
                        [_vModelText, formFieldsTenant.value.military_information.agent_city]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_185, [
                      _hoisted_186,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((formFieldsTenant.value.military_information.agent_state) = $event)),
                        type: "text",
                        disabled: formFieldsTenant.value.military_information.no_agent_given
                      }, null, 8, _hoisted_187), [
                        [_vModelText, formFieldsTenant.value.military_information.agent_state]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_188, [
                      _hoisted_189,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((formFieldsTenant.value.military_information.agent_postal_code) = $event)),
                        type: "text",
                        disabled: formFieldsTenant.value.military_information.no_agent_given
                      }, null, 8, _hoisted_190), [
                        [_vModelText, formFieldsTenant.value.military_information.agent_postal_code]
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_unref(api_settings).alternate_contact)
              ? (_openBlock(), _createElementBlock("div", _hoisted_191, [
                  _hoisted_192,
                  _createElementVNode("fieldset", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formFieldsTenant.value.contacts, (contact) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: contact.id + 'contact'
                      }, [
                        (_unref(api_settings).alternate_contact_description)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_193, [
                              _hoisted_194,
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((contact.description) = $event),
                                type: "text"
                              }, null, 8, _hoisted_195), [
                                [_vModelText, contact.description]
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_196, [
                          _hoisted_197,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((contact.first_name) = $event),
                            type: "text"
                          }, null, 8, _hoisted_198), [
                            [_vModelText, contact.first_name]
                          ])
                        ]),
                        (_unref(api_settings).alternate_contact_middle_initial)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_199, [
                              _hoisted_200,
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((contact.middle_initial) = $event),
                                type: "text"
                              }, null, 8, _hoisted_201), [
                                [_vModelText, contact.middle_initial]
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_202, [
                          _hoisted_203,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((contact.last_name) = $event),
                            type: "text"
                          }, null, 8, _hoisted_204), [
                            [_vModelText, contact.last_name]
                          ])
                        ]),
                        (_unref(api_settings).alternate_contact_email)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_205, [
                              _hoisted_206,
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((contact.email) = $event),
                                type: "text"
                              }, null, 8, _hoisted_207), [
                                [_vModelText, contact.email]
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_208, [
                          _hoisted_209,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contact.phone_numbers, (contact_number) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: contact_number.id + 'number',
                              class: "row"
                            }, [
                              (_unref(api_settings).alternate_contact_phone_label)
                                ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                    key: 0,
                                    "onUpdate:modelValue": ($event: any) => ((contact_number.label) = $event),
                                    class: "form-select"
                                  }, _hoisted_217, 8, _hoisted_210)), [
                                    [_vModelSelect, contact_number.label]
                                  ])
                                : _createCommentVNode("", true),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((contact_number.number) = $event),
                                class: "form-field",
                                type: "text",
                                placeholder: "primary number"
                              }, null, 8, _hoisted_218), [
                                [_vModelText, contact_number.number]
                              ]),
                              (_unref(api_settings).alternate_contact_phone_extension)
                                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                    key: 1,
                                    "onUpdate:modelValue": ($event: any) => ((contact_number.extension) = $event),
                                    class: "form-field",
                                    type: "text",
                                    placeholder: "extension"
                                  }, null, 8, _hoisted_219)), [
                                    [_vModelText, contact_number.extension]
                                  ])
                                : _createCommentVNode("", true),
                              (
                  contact.phone_numbers.length > 1 &&
                  _unref(api_settings).alternate_contact_multiple
                )
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 2,
                                    class: "btn btn-text",
                                    onClick: ($event: any) => (removeContactNumber(contact_number, contact))
                                  }, " Remove ", 8, _hoisted_220))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]),
                        (_unref(api_settings).alternate_contact_multiple)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 3,
                              class: "btn btn-text",
                              onClick: ($event: any) => (addContactNumber(contact))
                            }, " Add number ", 8, _hoisted_221))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_222, [
                          _hoisted_223,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((contact.address.address1) = $event),
                            type: "text"
                          }, null, 8, _hoisted_224), [
                            [_vModelText, contact.address.address1]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_225, [
                          _hoisted_226,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((contact.address.address2) = $event),
                            type: "text"
                          }, null, 8, _hoisted_227), [
                            [_vModelText, contact.address.address2]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_228, [
                          _hoisted_229,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((contact.address.city) = $event),
                            type: "text"
                          }, null, 8, _hoisted_230), [
                            [_vModelText, contact.address.city]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_231, [
                          _hoisted_232,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((contact.address.state) = $event),
                            type: "text"
                          }, null, 8, _hoisted_233), [
                            [_vModelText, contact.address.state]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_234, [
                          _hoisted_235,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((contact.address.postal) = $event),
                            type: "text"
                          }, null, 8, _hoisted_236), [
                            [_vModelText, contact.address.postal]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_237, [
                          _hoisted_238,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((contact.address.country) = $event),
                            type: "text"
                          }, null, 8, _hoisted_239), [
                            [_vModelText, contact.address.country]
                          ])
                        ])
                      ]))
                    }), 128))
                  ]),
                  (_unref(api_settings).sms_and_email_opt_in)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_240, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((emailNotify).value = $event)),
                            type: "checkbox"
                          }, null, 512), [
                            [_vModelCheckbox, emailNotify.value]
                          ]),
                          _hoisted_241
                        ]),
                        _createElementVNode("div", _hoisted_242, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((formFieldsTenant.value.sms_opt) = $event)),
                            type: "checkbox"
                          }, null, 512), [
                            [_vModelCheckbox, formFieldsTenant.value.sms_opt]
                          ]),
                          _hoisted_243
                        ])
                      ], 64))
                    : _createCommentVNode("", true),
                  (_unref(api_settings).allow_password)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _hoisted_244,
                        _createElementVNode("fieldset", null, [
                          (_unref(api_settings).username)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("div", _hoisted_245, [
                                  _hoisted_246,
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((formFieldsTenant.value.username) = $event)),
                                    type: "text"
                                  }, null, 512), [
                                    [_vModelText, formFieldsTenant.value.username]
                                  ])
                                ]),
                                (account.value)
                                  ? (_openBlock(), _createElementBlock("small", _hoisted_247, "Account has been created"))
                                  : _createCommentVNode("", true),
                                _hoisted_248,
                                (!allowSignUp.value && account.value)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 1,
                                      class: "btn btn-text",
                                      onClick: _cache[65] || (_cache[65] = ($event: any) => (allowSignUp.value = true))
                                    }, " Retry sign up "))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true),
                          (!account.value || allowSignUp.value)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createElementVNode("div", _hoisted_249, [
                                  _hoisted_250,
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((formFieldsTenant.value.password) = $event)),
                                    type: "password",
                                    minLength: "6"
                                  }, null, 512), [
                                    [_vModelText, formFieldsTenant.value.password]
                                  ]),
                                  _hoisted_251
                                ]),
                                (_unref(api_settings).password_recovery_questions_attributes)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      (!allowSignUp.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_252, [
                                            _hoisted_253,
                                            _withDirectives(_createElementVNode("textarea", {
                                              "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => ((
                    formFieldsTenant.value.password_recovery_questions_attributes[0]
                      .question
                  ) = $event))
                                            }, null, 512), [
                                              [_vModelText, 
                    formFieldsTenant.value.password_recovery_questions_attributes[0]
                      .question
                  ]
                                            ])
                                          ]))
                                        : _createCommentVNode("", true),
                                      (!allowSignUp.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_254, [
                                            _hoisted_255,
                                            _withDirectives(_createElementVNode("textarea", {
                                              "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => ((
                    formFieldsTenant.value.password_recovery_questions_attributes[0]
                      .answer
                  ) = $event))
                                            }, null, 512), [
                                              [_vModelText, 
                    formFieldsTenant.value.password_recovery_questions_attributes[0]
                      .answer
                  ]
                                            ])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (allowSignUp.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_256, [
                                      (signUpErrors.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_257, _toDisplayString(signUpErrors.value), 1))
                                        : _createCommentVNode("", true),
                                      (signUpSuccess.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_258, _toDisplayString(signUpSuccess.value), 1))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true),
                          (formFieldsTenant.value.web_password)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                (account.value)
                                  ? (_openBlock(), _createElementBlock("small", _hoisted_259, "Account has been created"))
                                  : _createCommentVNode("", true),
                                _hoisted_260
                              ], 64))
                            : _createCommentVNode("", true)
                        ])
                      ], 64))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (errors.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_261, _toDisplayString(errors.value), 1))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "btn",
              disabled: formSubmitting.value
            }, [
              (formSubmitting.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (__props.customerId)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _hoisted_263
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _hoisted_264
                        ], 64))
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (__props.customerId)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _hoisted_265
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _hoisted_266
                        ], 64))
                  ], 64))
            ], 8, _hoisted_262),
            _createVNode(_component_RouterLink, {
              to: 
        __props.customerId
          ? {
              name: 'customer_detail_storedge',
              params: { id: __props.customerId, facilityId: __props.facilityId },
            }
          : { name: 'customers', params: { facilityId: __props.facilityId } }
      
            }, {
              default: _withCtx(() => [
                _hoisted_267
              ]),
              _: 1
            }, 8, ["to"])
          ], 40, _hoisted_5))
        : _createCommentVNode("", true),
    (formErrors.value.server_error !== undefined)
      ? (_openBlock(), _createBlock(_component_BaseAlert, {
          key: 4,
          variant: "danger",
          class: "js-form-error",
          dismissible: "",
          onDismissed: _cache[69] || (_cache[69] = ($event: any) => (formErrors.value = {}))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(formErrors.value.server_error[0]), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})